"use client";

import { c as _c } from "react/compiler-runtime";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FocusTrap } from "focus-trap-react";
import { useId, useRef } from "react";
import { createPortal } from "react-dom";
import { useClickAway, useKeyPressEvent } from "react-use";
import type { ApiCreateGroup } from "@/generated/models/ApiCreateGroup";
import type { ApiGroupFull } from "@/generated/models/ApiGroupFull";
import GroupAssignmentPanel from "./GroupAssignmentPanel";
export default function GroupAssignmentDialog(t0) {
  const $ = _c(33);
  const {
    title,
    description,
    suggestedName,
    defaultLabel,
    selectedGroup,
    disabled: t1,
    allowGroupClear: t2,
    onClose,
    onChange,
    onCreateGroup
  } = t0;
  const disabled = t1 === undefined ? false : t1;
  const allowGroupClear = t2 === undefined ? true : t2;
  const modalRef = useRef(null);
  const titleId = useId();
  const descriptionId = useId();
  useClickAway(modalRef, onClose);
  let t3;
  if ($[0] !== onClose) {
    t3 = event => {
      if (event.defaultPrevented) {
        return;
      }
      const activeElement = document.activeElement as HTMLElement | null;
      if (activeElement && modalRef.current?.contains(activeElement) && (activeElement.tagName === "INPUT" || activeElement.tagName === "TEXTAREA" || activeElement.tagName === "SELECT" || activeElement.isContentEditable || activeElement.getAttribute("role") === "combobox")) {
        return;
      }
      onClose();
    };
    $[0] = onClose;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  useKeyPressEvent("Escape", t3);
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      allowOutsideClick: true,
      fallbackFocus: () => modalRef.current ?? document.body
    };
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="tw-fixed tw-inset-0 tw-bg-gray-950/75" />;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== title || $[5] !== titleId) {
    t6 = <p id={titleId} className="tw-mb-1.5 tw-text-lg tw-font-semibold tw-text-iron-50">{title}</p>;
    $[4] = title;
    $[5] = titleId;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== description || $[8] !== descriptionId) {
    t7 = <p id={descriptionId} className="tw-mb-0 tw-text-sm tw-leading-5 tw-text-iron-400">{description}</p>;
    $[7] = description;
    $[8] = descriptionId;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== t6 || $[11] !== t7) {
    t8 = <div className="tw-min-w-0 tw-flex-1">{t6}{t7}</div>;
    $[10] = t6;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t10;
  let t9;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <span className="tw-sr-only">Close</span>;
    t10 = <FontAwesomeIcon icon={faXmark} className="tw-size-4" />;
    $[13] = t10;
    $[14] = t9;
  } else {
    t10 = $[13];
    t9 = $[14];
  }
  let t11;
  if ($[15] !== onClose) {
    t11 = <button onClick={onClose} type="button" aria-label="Close dialog" className="tw-flex tw-size-9 tw-flex-shrink-0 tw-items-center tw-justify-center tw-rounded-lg tw-border-0 tw-bg-iron-900 tw-p-0 tw-text-iron-400 tw-transition tw-duration-200 desktop-hover:hover:tw-bg-iron-800 desktop-hover:hover:tw-text-iron-50">{t9}{t10}</button>;
    $[15] = onClose;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] !== t11 || $[18] !== t8) {
    t12 = <div className="tw-flex tw-flex-shrink-0 tw-items-start tw-justify-between tw-gap-4 tw-border-x-0 tw-border-b tw-border-t-0 tw-border-solid tw-border-white/5 tw-p-5 sm:tw-p-6">{t8}{t11}</div>;
    $[17] = t11;
    $[18] = t8;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[20] !== allowGroupClear || $[21] !== defaultLabel || $[22] !== disabled || $[23] !== onChange || $[24] !== onCreateGroup || $[25] !== selectedGroup || $[26] !== suggestedName) {
    t13 = <div className="tw-min-h-0 tw-flex-1 tw-overflow-y-auto tw-p-5 sm:tw-p-6"><GroupAssignmentPanel suggestedName={suggestedName} defaultLabel={defaultLabel} disabled={disabled} selectedGroup={selectedGroup} allowGroupClear={allowGroupClear} collapseOnClickAway={false} layout="dialog" startMode="existing" onChange={onChange} onCreateGroup={onCreateGroup} /></div>;
    $[20] = allowGroupClear;
    $[21] = defaultLabel;
    $[22] = disabled;
    $[23] = onChange;
    $[24] = onCreateGroup;
    $[25] = selectedGroup;
    $[26] = suggestedName;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  if ($[28] !== descriptionId || $[29] !== t12 || $[30] !== t13 || $[31] !== titleId) {
    t14 = createPortal(<FocusTrap focusTrapOptions={t4}><div className="tw-relative tw-z-50 tw-cursor-default">{t5}<div className="tw-fixed tw-inset-0 tw-z-10 tw-overflow-y-auto"><div className="tw-flex tw-min-h-full tw-items-end tw-justify-center tw-px-0 tw-pt-8 tw-text-center sm:tw-items-center sm:tw-p-4"><dialog ref={modalRef} aria-modal="true" aria-labelledby={titleId} aria-describedby={descriptionId} tabIndex={-1} open={true} className="tw-relative tw-m-0 tw-flex tw-max-h-[90dvh] tw-w-full tw-transform tw-flex-col tw-overflow-hidden tw-rounded-t-2xl tw-border tw-border-solid tw-border-white/10 tw-bg-iron-950 tw-p-0 tw-text-left tw-shadow-2xl tw-transition-all tw-duration-300 sm:tw-max-w-[44rem] sm:tw-rounded-2xl">{t12}{t13}</dialog></div></div></div></FocusTrap>, document.body);
    $[28] = descriptionId;
    $[29] = t12;
    $[30] = t13;
    $[31] = titleId;
    $[32] = t14;
  } else {
    t14 = $[32];
  }
  return t14;
}